import {
  IndexReviewsComponentMainDiv,
  IndexReviewsComponentReviewItesmDiv,
  IndexReviewsComponentReviewsSection,
} from "../../styles/indexcomponentsstyles/indexreviewcomponentstyles";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import { ReactComponent as BrainIcon } from "./assets/user-solid-full.svg";
import Logo  from "./assets/1.png";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
const IndexReviewsComponent = () => {
  return (
    <IndexReviewsComponentMainDiv>
      <div>
        <div className="reviews-background"></div>
        <div className="reviews-container">
          <div className="reviews-header">
            <div>
              <div>
                <HeaderSpan text="Customer reviews" />
              </div>
            </div>
            <div>
              <div className="reviews-header-text-container ">
                <h2> Hear from our customers & their success stories</h2>
              </div>
            </div>
          </div>
          <div className="reviews-content-holder">
            <IndexReviewsComponentReviewsSection
              length={data.length}
              itemwidth={364}
              gap={60}
            >
              <div>
                
                <section className="integration-review-section-container">
                  <div className="integration-review-section-holder">
                    <div className="reviews-marque-container">
                      <div className="reviews-marque-gradient-cover reviews-marque-gradient-cover-right" />
                      <div className="reviews-marque-gradient-cover reviews-marque-gradient-cover-left" />

                      <div className="reviews-marque-scroll-holder">
                        <section>
                          <ul className="reviews-marque-scroll-list">
                          
                            {data.map((item, index) => (
                              <IndexReviewsComponentReviewItesmDiv>
                                <div key={index + "marquee items"}>
                                  <div className="review-item-top">
                                    <div>
                                      <div className="review-item-icon">
                                        <BrainIcon fill="white " color="white" />
                                      </div>
                                    </div>
                                    <div>
                                      <div className="review-text-holder">
                                        <p>{item.review} </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="review-item-bottom">
                                    <div>
                                      <div className="review-item-pfp">
                                        <img src={Logo} alt="" />
                                      </div>
                                    </div>
                                    <div className="review-texts-container">
                                      <div>
                                        {" "}
                                        <div className="review-name-container">
                                          {" "}
                                          <p>{item.name} </p>
                                        </div>{" "}
                                      </div>
                                      <div>
                                        {" "}
                                        <div className="review-posotion-container">
                                          {" "}
                                          <p> {item.role}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </IndexReviewsComponentReviewItesmDiv>
                            ))}
                           
                            {data.map((item, index) => (
                              <IndexReviewsComponentReviewItesmDiv>
                                <div key={index + "marquee items"}>
                                  <div className="review-item-top">
                                    <div>
                                      <div className="review-item-icon">
                                        <BrainIcon fill="white " color="white" />
                                      </div>
                                    </div>
                                    <div>
                                      <div className="review-text-holder">
                                        <p>{item.review} </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="review-item-bottom">
                                    <div>
                                      <div className="review-item-pfp">
                                        <img src={Logo} alt="" />
                                      </div>
                                    </div>
                                    <div className="review-texts-container">
                                      <div>
                                        {" "}
                                        <div className="review-name-container">
                                          {" "}
                                          <p>{item.name} </p>
                                        </div>{" "}
                                      </div>
                                      <div>
                                        {" "}
                                        <div className="review-posotion-container">
                                          {" "}
                                          <p> {item.role}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </IndexReviewsComponentReviewItesmDiv>
                            ))}
                           
                          </ul>
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </IndexReviewsComponentReviewsSection>
          </div>
          <div>
           <div className="review-button-container">
            <ButtonComponentVariant title="leave a review " link="/review" />
          </div>
          </div>
        </div>
      </div>
    </IndexReviewsComponentMainDiv>
  );
};

const data = 
[
  {
    "id": 1,
    "name": "Mary Johnson",
    "role": "Bakery Owner",
    "company": "Sweet Crumbs",
    "avatar": "https://i.pravatar.cc/150?img=11",
    "rating": 4,
    "review": "When I wanted to take my bakery orders online, I thought it would be a nightmare. Bugzi AI guided me through setting up a simple order form, and suddenly customers could place requests without me juggling phone calls."
  },
  {
    "id": 2,
    "name": "Sarah Jenkins",
    "role": "Product Manager",
    "company": "CreativEdge",
    "avatar": "https://i.pravatar.cc/150?img=5",
    "rating": 5,
    "review": "I was hesitant at first, but after using it for a week, I can safely say it's a game-changer. It makes managing our application development significantly easier."
  },
  {
    "id": 3,
    "name": "Emeka Okafor",
    "role": "Freelance Photographer",
    "company": "Okafor Studios",
    "avatar": "https://i.pravatar.cc/150?img=19",
    "rating": 3,
    "review": "I needed a gallery site to showcase my work. Normally I’d have to hire someone, but Bugzi AI helped me spin up a simple self‑hosted page. It wasn’t perfect, but it got me started without stress."
  },
  {
    "id": 4,
    "name": "James Carter",
    "role": "Software Engineer",
    "company": "NextGen Tech",
    "avatar": "https://i.pravatar.cc/150?img=32",
    "rating": 5,
    "review": "Bugzi AI inside my IDE is a lifesaver. Switching between GPT and Claude for code suggestions makes debugging faster and more reliable. It feels like having multiple assistants at my fingertips."
  },
  {
    "id": 5,
    "name": "Aisha Bello",
    "role": "Startup Founder",
    "company": "GreenCart",
    "avatar": "https://i.pravatar.cc/150?img=41",
    "rating": 4,
    "review": "Launching our prototype seemed overwhelming, but Bugzi AI helped me build a basic tool for testing our idea. I didn’t have to learn coding from scratch — it felt like the system walked me through it."
  },
  {
    "id": 6,
    "name": "Daniel Smith",
    "role": "Project Manager",
    "company": "BrightWorks",
    "avatar": "https://i.pravatar.cc/150?img=47",
    "rating": 3,
    "review": "Our team needed a dashboard to track tasks. I’m not technical, but Bugzi AI helped me put together something functional. It wasn’t fancy, but it saved us time and gave us visibility quickly."
  },
  {
    "id": 7,
    "name": "Chinwe Nwosu",
    "role": "Community Organizer",
    "company": "Local Youth Hub",
    "avatar": "https://i.pravatar.cc/150?img=24",
    "rating": 4,
    "review": "For our youth events, registration was always messy. With Bugzi AI, I managed to set up a simple sign‑up page myself. Parents could register kids online, and it made coordination so much easier."
  }
]

export default IndexReviewsComponent;
